export const heroContent = {
  title: "Transform Data Into Profit",
  subtitle: "Custom analytics solutions that turn your business data into actionable insights and measurable growth.",
  ctaPrimary: "View Services",
  ctaSecondary: "Schedule Consultation"
};

export const trustedByLogos = [
  { name: "Okbox", logo: "/assets/okbox.png" },
  { name: "Replay Delivery", logo: "/assets/replay.png" },
  { name: "KB Tech", logo: "/assets/kb.png" },
  { name: "PneusBH", logo: "/assets/pneusbh.png" },
  { name: "Gooxie", logo: "/assets/gooxie.png" }
];

export const howItWorksSteps = [
  {
    number: "01",
    title: "Discovery & Diagnosis",
    description: "We analyze your current data infrastructure, identify gaps, and understand your business objectives to create a tailored strategy."
  },
  {
    number: "02",
    title: "Strategy & Proposal",
    description: "Receive a comprehensive proposal with clear deliverables, timelines, and ROI projections. No hidden costs, no surprises."
  },
  {
    number: "03",
    title: "Implementation & Optimization",
    description: "Our team builds, tests, and deploys your solution. We provide training and ongoing support to ensure maximum value."
  }
];

export const footerLinks = {
  company: [
    { label: "About", href: "/about" },
    { label: "Services", href: "/services" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "/contact" }
  ],
  services: [
    { label: "Sales Dashboards", href: "/services/automated-sales-dashboard" },
    { label: "Churn Prediction", href: "/services/customer-churn-prediction" },
    { label: "GA4 Audit", href: "/services/ga4-implementation-audit" },
    { label: "SEO Analytics", href: "/services/data-driven-seo-optimization" }
  ],
  contact: [
    { label: "lpfdataanalytics@gmail.com", href: "mailto:lpfdataanalytics@gmail.com" },
    { label: "WhatsApp", href: "https://wa.me/558896527079" },
    { label: "Schedule Call", href: "https://calendly.com/lpfanalytics" }
  ]
};
